module.exports = __webpack_public_path__ + "img/zhuanpan.156b3ed3.gif";